import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.n6o_1 = id;
        this.o6o_1 = name;
        this.p6o_1 = email;
        this.q6o_1 = badge;
        this.r6o_1 = callSignAdjective;
        this.s6o_1 = callSignNoun;
        this.t6o_1 = imageURL;
        this.u6o_1 = avatarType;
        this.v6o_1 = unvalidatedEmails;
        this.w6o_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.n6o_1.toString() + ', name=' + this.o6o_1 + ', email=' + this.p6o_1 + ', badge=' + toString(this.q6o_1) + ', callSignAdjective=' + this.r6o_1 + ', callSignNoun=' + this.s6o_1 + ', imageURL=' + toString(this.t6o_1) + ', avatarType=' + toString(this.u6o_1) + ', unvalidatedEmails=' + toString(this.v6o_1) + ', pins=' + toString(this.w6o_1) + ')';
      }
      hashCode() {
        var result = this.n6o_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.o6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p6o_1) | 0;
        result = imul(result, 31) + hashCode(this.q6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s6o_1) | 0;
        result = imul(result, 31) + hashCode(this.t6o_1) | 0;
        result = imul(result, 31) + hashCode(this.u6o_1) | 0;
        result = imul(result, 31) + hashCode(this.v6o_1) | 0;
        result = imul(result, 31) + hashCode(this.w6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.n6o_1.equals(other.n6o_1))
          return false;
        if (!(this.o6o_1 === other.o6o_1))
          return false;
        if (!(this.p6o_1 === other.p6o_1))
          return false;
        if (!equals(this.q6o_1, other.q6o_1))
          return false;
        if (!(this.r6o_1 === other.r6o_1))
          return false;
        if (!(this.s6o_1 === other.s6o_1))
          return false;
        if (!equals(this.t6o_1, other.t6o_1))
          return false;
        if (!equals(this.u6o_1, other.u6o_1))
          return false;
        if (!equals(this.v6o_1, other.v6o_1))
          return false;
        if (!equals(this.w6o_1, other.w6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
